// What the avatar endpoints accept (backend accounts/avatars.py, D9) —
// checked here first so a wrong file is refused before it's sent.
export const AVATAR_MAX_BYTES = 10 * 1024 * 1024;
export const AVATAR_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif",
];
